import { useMemo } from 'react';

import { useTranslations } from '@core/js/hooks/i18n';

import { useDynamicTagList } from '@interlayer/js/app/hooks/useDynamicTagList';
import { DYNAMIC_TAG_NAMES } from '@interlayer/js/app/utils/constants';

export const useQuestionOptions = () => {
    const t = useTranslations('playtech.mobile.system.registration.');
    const dTagOrderSecurityQuestionList = useDynamicTagList({
        tagName: DYNAMIC_TAG_NAMES.orderSecurityQuestionOptions,
        defaultValue: '1,2,3,4,5'
    });

    return useMemo(
        () => dTagOrderSecurityQuestionList
            .map(questionIndex => ({
                value: `question_${questionIndex}`,
                label: t(`securityQuestion.question_${questionIndex}`)
            })),
        [dTagOrderSecurityQuestionList, t]
    );
};
